<template>
    <div id="user-list">
        <v-card>
            <v-card-title> {{ $t("Näytöt") }} </v-card-title>
            <!-- actions -->
            <v-card-text class="mt-3">
                <v-data-table :headers="tableColumns" :items="screens" :loading="loading" mobile-breakpoint="0">

                    <template #[`item.actions`]="{ item }">
                        <v-btn :to="{ name: 'admin-infotv-screen-settings', params: { screen: item.id } }" small
                            color="primary" class="mr-3">
                            {{ $t('Asetukset') }}
                        </v-btn>
                        <v-btn :to="{ 'name': 'admin-infotv-screen-content', params: { 'screen': item.id } }" small
                            color="primary">
                            {{ $t('Sisältö') }}
                        </v-btn>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>


<script>
import { onMounted, ref, watch, computed } from "@vue/composition-api";
import adminApi from "@/api/admin";
import { mdiCheckboxMarkedCircle, mdiCloseCircle, mdiPlus } from "@mdi/js";
import { getDateTime } from "@/@core/utils/datetime_helpers";
import { i18n } from "@/plugins/i18n";

export default {
    setup() {
        const screens = ref([]);
        const options = ref({});
        const loading = ref(false);


        const tableColumns = computed(() => [
            { text: i18n.t("Näyttö").toUpperCase(), value: "name", sortable: false },
            { text: "", value: "actions", sortable: false },
        ]);

        // fetch data
        const fetchScreens = async () => {

            loading.value = true;
            const response = await adminApi.getInfoTvScreens();

            if (response.ok) {
                screens.value = response.data;
            }

            loading.value = false;
        };

        onMounted(() => {
            fetchScreens();
        });

        return {
            screens,
            tableColumns,
            options,
            loading,
            getDateTime,
            icons: {
                mdiCheckboxMarkedCircle,
                mdiCloseCircle,
                mdiPlus,
            },
        };
    },
};
</script>
